module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.err.has(_vm.id)) ? _c('div', {
    staticClass: "is-danger"
  }, [_vm._v(_vm._s(_vm.err.first(_vm.id)))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c711d82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ErrorMsg.vue
// module id = 746
// module chunks = 0